import { generatePath } from 'react-router-dom';
import encodeBase64 from '../../../utils/encodeBase64';

const ZITONEO_BASE_PATH = '/zitoneo';
const hotelsContentPath = `${ZITONEO_BASE_PATH}/hotels-content`;
const hotelPresentationPath = `${hotelsContentPath}/:idEncoded`;

/** Parameterized paths for route declarations and matching. */
export const zitoneoRouteDefinitions = {
    BASE_PATH: ZITONEO_BASE_PATH,
    HOTELS_CONTENT_LIST: hotelsContentPath,
    HOTEL_PRESENTATION: hotelPresentationPath,
    HOTEL_CONTENT: `${hotelPresentationPath}/content`,
    HOTEL_EDITOR_HOTEL: `${hotelPresentationPath}/content/editor/hotel/:contentType`,
    HOTEL_EDITOR_ROOM: `${hotelPresentationPath}/content/editor/room/:roomIdEncoded/:contentType`,
    HOTEL_PREVIEW: `${hotelPresentationPath}/content/preview`,
    HOTEL_SETTINGS: `${hotelPresentationPath}/content/settings`,
};

/** Navigation URLs generated from the definitions using unencoded IDs. */
export const zitoneoRoutes = {
    BASE_PATH: ZITONEO_BASE_PATH,
    HOTELS_CONTENT_LIST: zitoneoRouteDefinitions.HOTELS_CONTENT_LIST,
    HOTEL_PRESENTATION: (id: string | number) =>
        generatePath(zitoneoRouteDefinitions.HOTEL_PRESENTATION, {
            idEncoded: encodeBase64(id),
        }),
    HOTEL_CONTENT: (id: string | number) =>
        generatePath(zitoneoRouteDefinitions.HOTEL_CONTENT, {
            idEncoded: encodeBase64(id),
        }),
    HOTEL_EDITOR_HOTEL: (id: string | number, contentType = 'services') =>
        generatePath(zitoneoRouteDefinitions.HOTEL_EDITOR_HOTEL, {
            idEncoded: encodeBase64(id),
            contentType,
        }),
    HOTEL_EDITOR_ROOM: (
        id: string | number,
        roomId: string | number,
        contentType = 'services'
    ) =>
        generatePath(zitoneoRouteDefinitions.HOTEL_EDITOR_ROOM, {
            idEncoded: encodeBase64(id),
            roomIdEncoded: encodeBase64(roomId),
            contentType,
        }),
    HOTEL_PREVIEW: (id: string | number) =>
        generatePath(zitoneoRouteDefinitions.HOTEL_PREVIEW, {
            idEncoded: encodeBase64(id),
        }),
    HOTEL_SETTINGS: (id: string | number) =>
        generatePath(zitoneoRouteDefinitions.HOTEL_SETTINGS, {
            idEncoded: encodeBase64(id),
        }),
};
